<template>
  <div class="text-left pb-12 bg-gray-50">
    <div class="px-6 bg-nw-red">
      <div class="pt-8" @click="close">
        <close-icon :width="'w-4'" :color="'text-white'"></close-icon>
      </div>
      <div class="text-sm font-extrabold w-full pt-5 pb-3 text-white">ORDER CONFIRMED</div>
      <div class="text-white inline-block">
        <div class="text-xs">Progress:</div>
        <div class="text-lg font-extrabold">25 %</div>
      </div>
      <div class="text-white float-right text-right inline-block -mt-4">
        <div class="text-xs">
          Give rider this <br />
          code at pick-up
        </div>
        <div class="text-lg font-extrabold">7 A 0 B 5 E</div>
      </div>
      <div class="w-full flex pb-8 pt-2">
        <div class="w-3/12 h-1.5 bg-white rounded-sm"></div>
        <div class="w-9/12 h-1.5 bg-nw-fade-red rounded-r-sm"></div>
      </div>
    </div>
    <div class="-mt-4 mx-6 bg-white shadow-md px-7 py-6">
      <div class="flex">
        <div class="pr-3">
          <div class="pb-0.5">
            <progress-icon></progress-icon>
          </div>
          <div class="border border-gray-400 h-11 w-0.5 ml-2"></div>
          <div class="pb-0.5">
            <progress-icon></progress-icon>
          </div>
          <div class="border border-gray-400 h-11 w-0.5 ml-2"></div>
          <div class="rounded-2xl block w-4 h-4 border border-nw-red my-1"></div>
          <div class="border border-gray-400 h-11 w-0.5 ml-2"></div>
          <div class="rounded-2xl block w-4 h-4 border border-green-400 my-1"></div>
        </div>
        <div>
          <div class="pb-10">
            <div class="text-xxxs text-gray-500">20:30</div>
            <div class="text-xs font-bold">The rider has arrived pick-up location</div>
          </div>
          <div class="pb-10">
            <div class="text-xxxs text-gray-500">20:32</div>
            <div class="text-xs font-bold">The rider has picked up the package</div>
          </div>
          <div class="pb-5 xs:pb-10">
            <div class="text-xxxs text-gray-500">--:--</div>
            <div class="text-xs text-gray-300 font-bold">The rider is on the way to receiver’s location</div>
          </div>
          <div class="">
            <div class="text-xxxs text-gray-500">--:--</div>
            <div class="text-xs text-gray-300 font-bold">The rider is on the way to receiver’s location</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/components/icons/CloseIcon.vue'
import ProgressIcon from '../components/icons/ProgressIcon.vue'

export default {
  components: { CloseIcon, ProgressIcon },
  methods: {
    close() {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  }
}
</script>
